import PropTypes from 'prop-types';

import { getSrc } from './video-utils';

const VideoComponent = ({ blockProps, className = '', style, theme }) => {
    const src = getSrc(blockProps);
    if (src) {
        return (
            <div style={style} className={`${theme.iframeContainer} ${className}`}>
                <iframe
                    width="640"
                    height="360"
                    className={theme.iframe}
                    src={src}
                    frameBorder="0"
                    allowFullScreen
                    allow={'fullscreen'}
                    loading="lazy"
                />
            </div>
        );
    }

    return (
        <div className={theme.invalidVideoSrc}>Lenken du forsøker å bruke er ikke riktig Vimeo eller Youtube lenke</div>
    );
};

VideoComponent.propTypes = {
    blockProps: PropTypes.object.isRequired,
    className: PropTypes.string,
    style: PropTypes.object,
    theme: PropTypes.object.isRequired,
};

export default VideoComponent;
